const page = require('../../../../../components/page/page')
const purchaseDeletedDt = require('./purchaseDeleted-dt')
import purchaseDeletedPage from './purchaseDeleted-page.html'

let HTMLwasSelected = false

function HTMLselect() {
  document.body.insertAdjacentHTML('beforeend', purchaseDeletedPage)
  HTMLwasSelected = true
}

export function start(detail) {
  if (!HTMLwasSelected) HTMLselect()
  if (detail.act === 'show') {
    page.start(detail)
    purchaseDeletedDt.start({
      dest: 'purchaseDeleted',
      elem: 'dt',
      act: 'select',
      entity: 'purchaseDeleted'
    })
  }
}

